import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Algarve Boat Charters · Private Yacht from Vilamoura · Morningstar";
const DESC =
  "Private Algarve boat charters from Vilamoura aboard Morningstar — a 200 m² crewed yacht for up to 18 guests. Half-day, sunset, Benagil Cave and full-day Algarve cruises.";
const PATH = "/algarve-boat";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.algarveBoat;

export const Route = createFileRoute("/algarve-boat")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: CONTENT.en.eyebrow,
        title: "Algarve boat charters aboard ",
        titleAccent: "Morningstar.",
        sub: "A 200 m² private yacht from Marina de Vilamoura — fully crewed and catered, for up to 18 guests. Benagil, Marinha, Vilamoura sunsets and Ria Formosa.",
        ctaPrimary: "View cruises",
        ctaSecondary: "Ask about charters",
      }}
      pageContent={CONTENT.en}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "algarve boat, algarve boat charter, algarve boat trip, private boat algarve, boat in algarve, algarve yacht",
      altPath: { en: PATH, pt: "/pt/barco-algarve" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Algarve Boat Charters from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Algarve Boat Charters", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.en.faqs)) },
      ],
    }),
});